import { isNotDefined } from '@sgme/fp';

import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { swapApi } from '@/store/swap/api';
import { selectSwapTile } from '@/store/swap/selectors/tile.ts';
import { getSwapTradeCaptureQueue } from '@/store/swap/swapTradeCaptureQueue.ts';
import { duplicateTile } from '@/store/tiles/slice.ts';

// this listener call trade capture after a duplicate tile
// @see esp-listener for ESP price subscription after duplicate
export const registerDuplicateSwapTradeCaptureListenersForCash = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: duplicateTile,
    effect: async (action, api) => {
      const state = api.getState();

      const sourceTile = selectSwapTile(state, action.payload.sourceTileId);

      if (isNotDefined(sourceTile)) {
        return;
      }

      const { rfs: _, ...tilePropertiesWithoutRfs } = sourceTile.properties;

      void getSwapTradeCaptureQueue(action.payload.newTileId).add(async () => {
        await api.dispatch(
          swapApi.endpoints.checkSwapByTradeCapture.initiate({
            ...sourceTile,
            properties: tilePropertiesWithoutRfs,
            tileId: action.payload.newTileId,
            // isNonDeliverable: undefined
          }),
        );
      });
    },
  });
};
